import React from 'react';
import PropTypes from 'prop-types';

const Pending = ({ size, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 48 48"
  >
    <rect width="48" height="48" fill="#E6F3FD" rx="24"></rect>
    <path
      fill="#0189ED"
      d="M24.003 16.5c1.768 0 3.466.634 4.807 1.755l-3.483 3.483 9.317.808-.809-9.316-2.895 2.895a10.52 10.52 0 0 0-6.937-2.626c-5.15 0-9.504 3.681-10.355 8.751l2.96.497a7.47 7.47 0 0 1 7.395-6.247M24 31.5a7.5 7.5 0 0 1-4.807-1.755l3.483-3.483-9.317-.809.809 9.317 2.895-2.895A10.52 10.52 0 0 0 24 34.5c5.15 0 9.504-3.681 10.355-8.751l-2.96-.497A7.47 7.47 0 0 1 24 31.5"
    ></path>
  </svg>
);

Pending.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

Pending.defaultProps = {
  size: 48,
  className: '',
};

export default Pending;
